import api from './axios';

export const installationAPI = {
  getAll: async (page = 1, limit = 10, isActive = true) => {
    const response = await api.get('/installations', {
      params: { page, limit, isActive },
    });
    return response.data;
  },

  getById: async (uniqueId) => {
    const response = await api.get(`/installation/${uniqueId}/configs`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/installation', data);
    return response.data;
  },

  update: async (uniqueId, data) => {
    const response = await api.put(`/installation/${uniqueId}`, data);
    return response.data;
  },

  delete: async (uniqueId) => {
    const response = await api.delete(`/installation/${uniqueId}`);
    return response.data;
  },

  getStatistics: async () => {
    const response = await api.get('/stats');
    return response.data;
  },
};
